<template>
  <v-container>
    <v-stepper v-model="step">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="step > 1"
          >Datei auswählen</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="step > 2"
          >Felder definieren</v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="step > 3">Vorschau</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" :complete="step > 4"
          >Import & Kontrolle</v-stepper-step
        >
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <v-card>
            <v-card-text>
              <file-selector
                @filesSelected="fileChanged"
                displayText="Drag'n drop oder klicken um Datei auszuwählen"
              />
              <div class="ma-2">Datei: {{ fileName }}</div>
              <div>
                <v-switch
                  v-model="csvHeader"
                  label="Spaltennamen"
                  color="green"
                />
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cancelImport" outlined color="red"
                >Abbrechen</v-btn
              >
              <v-btn :disabled="!!!file" @click="parseFile()" color="primary"
                >Weiter</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card>
            <v-card-text>
              <v-simple-table dense fixed-header>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left" width="50%">Datenbank Feldname</th>
                      <th class="text-left">CSV Feldname</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(col, index) in importHeaders" :key="index">
                      <td>{{ col.text }}</td>
                      <td>
                        <v-select
                          dense
                          solo
                          class="mt-3"
                          @change="mapField"
                          :items="mappingFields"
                          :item-value="
                            item => {
                              return {
                                index: index,
                                value: item.value
                              };
                            }
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="cancelImport" outlined color="red"
                >Abbrechen</v-btn
              >
              <v-btn @click="step = 1" outlined color="primary">Zurück</v-btn>
              <v-btn @click="mapCSVData()" color="primary">Weiter</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card>
            <v-card-text>
              <v-data-table
                :headers="importHeaders"
                :items="mappedDataItems"
                :items-per-page="5"
              >
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="step = 2" outlined color="primary">Zurück</v-btn>
              <v-btn @click="uploadData()" color="primary"
                >Import starten</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card>
            <v-card-text>
              <v-alert
                v-if="
                  importResult &&
                    importResult.success.length > 0 &&
                    importResult.failed.length == 0
                "
                border="left"
                type="success"
                elevation="2"
                color="green"
              >
                Import erfolgreich! {{ importResult.total }} Einträge
                importiert.
              </v-alert>
              <v-alert
                v-else-if="
                  importResult &&
                    importResult.success.length > 0 &&
                    importResult.failed.length > 0
                "
                border="left"
                type="warning"
                elevation="2"
                color="orange"
              >
                Import erfolgreich mit Warnungen! Gesamt:
                {{ importResult.total }} Einträge. Davon importiert:
                {{ importResult.success.length }}
              </v-alert>
              <v-alert
                v-else-if="importResult"
                border="left"
                type="error"
                elevation="2"
                color="red"
              >
                Import fehlgeschlagen. Gesamt:
                {{ importResult.total }} Einträge. Davon fehlerhaft:
                {{ importResult.failed.length }}
              </v-alert>
              <v-data-table
                :headers="importedHeaders"
                :items="importedDataItems"
              >
                <template slot="item.importStatus" slot-scope="{ item }">
                  <v-icon v-if="item.importStatus" color="green"
                    >mdi-check</v-icon
                  >
                  <v-icon v-else color="red">mdi-cancel</v-icon>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="closeDialog()">Schließen</v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>

<script>
//import chardet from "chardet";
import papaparse from "papaparse";
import fileSelector from "./fileSelector";

export default {
  name: "csvImport",
  components: { fileSelector },
  props: {
    useIgnoreMapping: {
      type: Boolean,
      default: true
    },
    ignoreMappingText: {
      type: String,
      default: "Ignorieren"
    },
    axiosInstance: {
      type: Function,
      required: true
    },
    importUrl: {
      type: String,
      required: true
    },
    importFields: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    step: 1,
    importFileData: null,
    importResult: null,
    csvHeader: true,
    fileError: false,
    fileName: null,
    file: null,
    mappingFields: [],
    mappedFields: [],
    mappedDataItems: [],
    importedDataItems: [],
    parsedData: [],
    importHeaders: []
  }),
  computed: {
    importedHeaders() {
      return [
        { text: "ImportStatus", value: "importStatus" },
        ...this.importHeaders
      ];
    }
  },

  methods: {
    resetWizard() {
      this.step = 1;
      (this.importFileData = null), (this.file = null);
      this.fileName = null;
      this.importResult = null;
      this.mappingFields = [];
      this.mappedFields = [];
      this.mappedDataItems = [];
      this.parsedData = [];
      this.importedDataItems = [];
    },
    cancelImport() {
      this.$emit("cancel");
      this.resetWizard();
    },
    closeDialog() {
      this.$emit("close", this.importErrors);
      this.resetWizard();
    },
    uploadData() {
      let vm = this;
      this.$store.commit("SET_APP_LOADING", true);
      this.step++;
      if (this.axiosInstance) {
        this.axiosInstance
          .post(this.importUrl, { data: this.mappedDataItems })
          .then(result => {
            this.importResult = result.data;
            if (result.data) {
              //importDialog send an array with index 0 is the count index and the index 1 ist the import object
              result.data.success.forEach(item => {
                item[1].importStatus = true;
                vm.importedDataItems.push(item[1]);
              });

              result.data.failed.forEach(item => {
                item[1].importStatus = false;
                vm.importedDataItems.push(item[1]);
              });
            }
            this.$emit("importCompleted", result.data);
          })
          .catch(error => {
            console.log(error);
            //this.importResult = result.data;
            this.$emit("importErrors", error);
          })
          .finally(() => {
            this.$store.commit("SET_APP_LOADING", false);
          });
      }
    },
    csvFields(csvFields) {
      let fields = [];
      if (this.useIgnoreMapping) {
        fields.push({ text: this.ignoreMappingText, value: -1 });
      }

      if (this.csvHeader) {
        for (let index in csvFields) {
          fields.push({ text: csvFields[index], value: index });
        }
      } else {
        for (let index in csvFields) {
          fields.push({ text: `Spalte ${Number(index) + 1}`, value: index });
        }
      }

      this.mappingFields = fields;
      //predefine all with ignore
      for (let i = 0; i < this.importHeaders.length; i++) {
        this.mappedFields[i] = -1;
      }
    },
    fileChanged(files) {
      this.file = files[0];
      this.fileName = files[0].name;
    },
    mapField(data) {
      if (data.index == -1) {
        return;
      }
      this.mappedFields[data.index] = data.value;

      //console.log("CSV Index: ", data.value);
      //console.log("DB Index", data.index, this.importHeaders[data.index].value);
    },
    mapCSVData() {
      //console.log(this.mappedFields);
      this.mappedDataItems = [];
      for (let index in this.parsedData.data) {
        const row = this.parsedData.data[index];

        let mappedData = {};
        for (let i = 0; i < this.mappedFields.length; i++) {
          const dbKey = this.importHeaders[i].value;
          let csvKey = Number.parseInt(this.mappedFields[i]);
          let csvData = "";

          if (csvKey != -1) {
            if (this.csvHeader) {
              csvKey = this.mappingFields.find(item => item.value == csvKey)
                .text;
            }
            if (csvKey) {
              csvData = row[csvKey];
            }
          }

          mappedData[dbKey] = csvData;
        }
        this.mappedDataItems.push(mappedData);
      }
      this.step++;
    },
    parseFile() {
      let vm = this;
      papaparse.parse(this.file, {
        header: this.csvHeader,
        complete: function(results) {
          vm.parsedData = results;
          let fields = results.data[0];
          if (results.meta.fields) {
            fields = results.meta.fields;
          }
          vm.csvFields(fields);
          vm.step++;
        }
      });
    }
  },

  created() {
    this.importHeaders = this.importFields;
  }
};
</script>
